import { Box } from '@mui/material'
import RVUs from 'components/user/RVUs/RVUs';
import AllPatientsTable from 'components/tables/AllPatients/AllPatientsTable';
import useGlobalStyles from 'styles/globalStyles';
import { useAuth } from 'context/AuthContext';
export default function DashboardPage() {
  const { doctor } = useAuth();
  const globalStyles = useGlobalStyles();

  return (
    <Box className={globalStyles.container} p={3}>
      {!doctor && <Box>
        <RVUs />
      </Box>}

      <Box mt={!doctor ? 3 : 0}>
        <AllPatientsTable
          showAddPatientButton
        />
      </Box>

    </Box>
  )
}
